import { render, staticRenderFns } from "./debut-stream.vue?vue&type=template&id=1c1a7247&scoped=true&lang=pug&"
import script from "./debut-stream.vue?vue&type=script&lang=js&"
export * from "./debut-stream.vue?vue&type=script&lang=js&"
import style0 from "./debut-stream.vue?vue&type=style&index=0&id=1c1a7247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a7247",
  null
  
)

export default component.exports